import React, { useState, useEffect } from "react"
import { Link } from "@quarkly/widgets"

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener("scroll", toggleVisibility)
    return () => window.removeEventListener("scroll", toggleVisibility)
  }, [])

  const scrollToTop = e => {
    e.preventDefault()
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  if (!isVisible) {
    return null
  }

  return (
    <Link
      href="#"
      onClick={scrollToTop}
      position="fixed"
      bottom="20px"
      right="20px"
      z-index="100"
      background="--color-dark"
      color="--color-light"
      width="40px"
      height="40px"
      border-radius="50%"
      display="flex"
      align-items="center"
      justify-content="center"
      text-decoration-line="none"
      box-shadow="0px 4px 10px rgba(0,0,0,0.2)"
      transition="opacity 0.3s ease, transform 0.3s ease"
      opacity="0.8"
      hover-opacity="1"
      hover-transform="translateY(-3px)"
      quarkly-title="Up Arrow"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 20V4M12 4L5 11M12 4L19 11"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Link>
  )
}
